import { ActionIcon, Flex } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

export const CellShowAction = (props: {
	onShow: MouseEventHandler<HTMLButtonElement>;
	data: any;
}) => {
	const { onShow } = props;
	return (
		<Flex gap="10px" justify={'flex-end'}>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="filled"
				radius={'xl'}
				color={'#DDF9ED'}
				onClick={onShow}
			>
				<IconEye
					color="#2C8C5E"
					size="18px"
					stroke={1.5}
				/>
			</ActionIcon>
		</Flex>
	);
};
